import { render } from "./campaign.vue?vue&type=template&id=3c80dc58"
import script from "./campaign.vue?vue&type=script&lang=js"
export * from "./campaign.vue?vue&type=script&lang=js"

import "./campaign.vue?vue&type=style&index=0&id=3c80dc58&lang=css"

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__